<script setup lang="ts">
import { IconItem, TypographyItem } from '@rfc/rfc-components-library'
import { EColors } from '@rfc/rfc-components-library/types';
</script>

<template>
    <TypographyItem :label="$t('device.rental.nextRentals')">
        <IconItem icon="information" :type="EColors.WARNING" />
    </TypographyItem>
</template>
